import React from 'react';

const PageHeaderItemWrapper = ({ children, ...props }) => (
  <div className="md:w-max w-full" {...props}>
    {children}
  </div>
)

export default PageHeaderItemWrapper;